@if (placeholder) {
  <div
    class="placeholder"
    role="button"
    tabindex="0"
    [attr.aria-label]="'Video.Play' | translate"
    (pointerover)="warmup()"
    (click)="activate()"
  >
    <img [attr.src]="placeholderImageSrcUrl | bypassSecurityTrustUrl" aria-hidden="true" class="placeholder__img" />
    <div class="placeholder__btn"></div>
  </div>
}
